/* eslint-disable max-len */
import { createRoot } from 'react-dom/client';
import html2pdf from 'html2pdf.js';
import { PDF_RENDER_TIME_DELAY_MS } from 'constant/constants';

export const generateInvoicePdf = async (component) => {
  // Create a div element to render the React component
  const container = document.createElement('div');

  // Attach the container to the body
  document.body.appendChild(container);

  // Use createRoot to render the React component into the container
  const root = createRoot(container);
  root.render(component);

  const option = {
    margin: [10, 10, 25, 10],
    filename: 'Estimate.pdf',
    image: { type: 'jpeg', quality: 0.7 },
    html2canvas: {
      scale: 2,
      allowTaint: true,
      useCORS: true,
      letterRendering: true,
      logging: true
    },
    // Set orientation to landscape
    jsPDF: { unit: 'mm', format: [297, 220] }
  };
  // Wait for the component to be fully rendered
  await new Promise((resolve) => setTimeout(resolve, PDF_RENDER_TIME_DELAY_MS));

  try {
    // Apply CSS styles to enable text selection
    container.style.userSelect = 'text';
    const optionsForPDF = option;

    const footer = 'Page {pageNumber} | {totalPages}';

    // Use html2pdf to convert the rendered component to a PDF
    // await html2pdf().from(container).set(optionsForPDF).save();
    const pdf = await html2pdf()
      .from(container)
      .set(optionsForPDF)
      .toPdf()
      .get('pdf')
      .then(function (pdf) {
        const totalPages = pdf.internal.getNumberOfPages();
        const img = new Image();
        img.src = '/logos/TRA-logo.jpg';
        for (let i = 1; i <= totalPages; i++) {
          // Add header
          pdf.setPage(i);
          // Add footer
          pdf.setFontSize(10);
          pdf.addImage(img, 'png', 93, 280, 30, 10); // x, y, width, height
          pdf.text(
            footer.replace('{pageNumber}', i).replace('{totalPages}', totalPages),
            pdf.internal.pageSize.getWidth() - 25,
            pdf.internal.pageSize.getHeight() - 10
          );
        }
      })
      .output('blob');

    // Cleanup: unmount the component and remove the container from the DOM
    root.unmount();
    container.remove();

    return pdf;
  } catch (error) {
    console.error('Error while generating PDF:', error);

    // Cleanup: unmount the component and remove the container from the DOM
    root.unmount();
    container.remove();

    throw error; // Re-throw the error
  }
};
